import * as weeklySalesData from '../services/weeklySalesData';

export default {
  namespace: 'weeklySalesData',

  state: {
    tableList: [],
    allTotal: 0,
  },

  effects: {
    *queryIncomeStatementList({ payload: { values } }, { call, put }) {
      const response = yield call(
        weeklySalesData.queryIncomeStatementList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          tableList: response?.data?.data || [],
          allTotal: response?.data?.total || 0,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
